import TicketsApi from '@app/api/public/TicketsApi';
import { ticketQueryKeys } from '@app/shared/queryKeys/tickets';
import { useQuery } from 'react-query';

const useGetServiceText = () => {
    return useQuery(ticketQueryKeys.serviceText(), () => TicketsApi.getInfoText());
};

export { useGetServiceText };
